import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createTextVNode("kcal: "),
  /*#__PURE__*/_createElementVNode("em", null, "der"),
  /*#__PURE__*/_createTextVNode(" Kalorien-Calculator")
], -1)
const _hoisted_2 = { id: "sec-calculation" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { for: "checkbox" }, "manu. Gewichtskorrektur", -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { id: "sec-ingredients" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", null, "Zutaten", -1)
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("button", null, "Hinzuf.", -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("em", null, "Keine Zutaten", -1)
const _hoisted_13 = [
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_serving_result = _resolveComponent("serving-result")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("p", null, [
        _createElementVNode("label", null, [
          _createTextVNode(" Gewünschter Brennwert (kcal): "),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.targetedKilocalories) = $event)),
            type: "number",
            min: "0"
          }, null, 512), [
            [
              _vModelText,
              _ctx.targetedKilocalories,
              void 0,
              { number: true }
            ]
          ])
        ])
      ]),
      _createElementVNode("p", null, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          id: "checkbox",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.withManualWeightCorrection) = $event))
        }, null, 512), [
          [_vModelCheckbox, _ctx.withManualWeightCorrection]
        ]),
        _hoisted_3
      ]),
      (_ctx.withManualWeightCorrection)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
            _createElementVNode("label", null, [
              _createTextVNode(" Korrektur (g): "),
              (!_ctx.isAndroid)
                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 0,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.manualWeightCorrection) = $event)),
                    type: "number"
                  }, null, 512)), [
                    [
                      _vModelText,
                      _ctx.manualWeightCorrection,
                      void 0,
                      { number: true }
                    ]
                  ])
                : _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 1,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.manualWeightCorrection) = $event)),
                    inputmode: "text"
                  }, null, 512)), [
                    [
                      _vModelText,
                      _ctx.manualWeightCorrection,
                      void 0,
                      { number: true }
                    ]
                  ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("p", null, "Gesamtmasse: " + _toDisplayString(_ctx.overallAmount.toFixed(0)) + "g", 1),
      _createElementVNode("p", null, "Berechn. Portion: " + _toDisplayString(_ctx.calculatedWeight.toFixed(0)) + "g", 1)
    ]),
    _createElementVNode("section", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("form", {
        onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addIngredient && _ctx.addIngredient(...args)), ["prevent"]))
      }, [
        _createElementVNode("p", null, [
          _createElementVNode("label", null, [
            _createTextVNode(" Name: "),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.ingredientForm.name) = $event)),
              id: "new-ingredient-name",
              placeholder: 'Zutat ' + (_ctx.ingredients.length+1)
            }, null, 8, _hoisted_7), [
              [
                _vModelText,
                _ctx.ingredientForm.name,
                void 0,
                { trim: true }
              ]
            ])
          ])
        ]),
        _createElementVNode("p", null, [
          _createElementVNode("label", null, [
            _createTextVNode(" Brennwert (kcal/100g): "),
            _withDirectives(_createElementVNode("input", {
              type: "number",
              min: "0",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.ingredientForm.caloriesPerHundredGrams) = $event))
            }, null, 512), [
              [
                _vModelText,
                _ctx.ingredientForm.caloriesPerHundredGrams,
                void 0,
                { number: true }
              ]
            ])
          ])
        ]),
        _createElementVNode("p", null, [
          _createElementVNode("label", null, [
            _createTextVNode(" Menge (g): "),
            _withDirectives(_createElementVNode("input", {
              type: "number",
              min: "1",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.ingredientForm.amountInGrams) = $event))
            }, null, 512), [
              [
                _vModelText,
                _ctx.ingredientForm.amountInGrams,
                void 0,
                { number: true }
              ]
            ])
          ])
        ]),
        _hoisted_8
      ], 32),
      (_ctx.ingredients.length > 0)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ingredients, (ingredient, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: ingredient.name
              }, [
                _createTextVNode(_toDisplayString(ingredient.name) + ", " + _toDisplayString(ingredient.caloriesPerHundredGrams) + "kcal/100g, " + _toDisplayString(ingredient.amountInGrams) + "g ", 1),
                _createElementVNode("button", {
                  onClick: ($event: any) => (_ctx.removeIngredient(index))
                }, "Entfernen", 8, _hoisted_10)
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("p", _hoisted_11, _hoisted_13))
    ]),
    _createVNode(_component_serving_result, {
      "data-ingredients": JSON.stringify(_ctx.servingIngredients)
    }, null, 8, ["data-ingredients"])
  ], 64))
}